module.exports = () ->
  return {
    restrict: 'A'
    controller: ($scope, $uibModal, Api) ->
      $scope.openModal = () ->
        modalInstance = $uibModal.open
          template: require('./source-modal.html')
          controller: require('./SourceInfoModalController')
          resolve:
            source: () ->
              if typeof $scope.engine is 'object'
                return $scope.engine
              else
                if $scope.url
                  return Api.Engine.get({url: $scope.url}).$promise.then ( response ) ->
                    return response.results[0]
                return Api.Engine.get({id: $scope.engine}).$promise.then ( engine ) ->
                  return engine
            image: () ->
              return $scope.krakensnapshot
    size: 'lg'
    scope:
      engine: '='
      krakensnapshot: '='
      url: '='
    template: '<span class="source-info-help glyphicons glyphicons-info-sign" ng-click="openModal()"></span>'
  }
